import { render } from "./CliAcceptanceOfCoverSection.vue?vue&type=template&id=0f2462be&ts=true"
import script from "./CliAcceptanceOfCoverSection.vue?vue&type=script&lang=ts"
export * from "./CliAcceptanceOfCoverSection.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__